<template>
  <div ref="customPageReport" class="custom-page-report-container">
    <div v-if="showOperation" class="left-container">
      <div class="left-content">
        <div class="line">
          <div class="title">辅助表</div>
          <public-combobox
            ref="auxiliaryTable"
            v-model="data.reportParams.auxiliaryTableId"
            :showOperationLength="10"
            :options="auxiliaryTables"
            :clearable="false"></public-combobox>
        </div>
        <div class="line update-line">
          <div class="title">定时更新</div>
          <public-combobox v-model="data.reportParams.timing" :options="timeList"></public-combobox>
        </div>
        <div class="report-style-setting" v-if="data">
          <style-setting :data="data" :collapses="data.styleList" @recoverSetting="recoverSetting"></style-setting>
        </div>
      </div>
      <div class="operation">
        <el-button type="primary" @click="save">保存</el-button>
        <el-button @click="closeDialog">关闭</el-button>
      </div>
    </div>
    <div :class="getClass" class="right-container" :style="{'background-color': getBgc(data.backgroundAndBorder)}">
      <div class="noReport" v-if="!this.report.id">选择数据,将会生成一个新的报表</div>
      <el-table
        ref="table"
        v-else
        v-loading="loading"
        :data="report.tableData"
        height="100%"
        style="width: 100%;"
        :row-style="rowStyle"
        :header-row-style="headerRowStyle">
        <template v-for="column in reportColumns">
          <el-table-column
            :width="column.runtimeWidth"
            :prop="column.id"
            :label="column.name"
            :key="column.id"
            :align="(column.format && column.format.dataFormat && column.format.dataFormat.align)||'center'"
            :show-overflow-tooltip="!judgeColumn(column)">
            <template slot="header" slot-scope="{row, column, $index}">
              <span :title="column.label">{{column.label}}</span>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
  </div>
</template>

<script>
import publicCombobox from '@/components/public/public-combobox.vue'
import moment from 'moment'
import styleSetting from './style-setting/style-setting'
import setStyle from '../../../public/setStyle'
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    isRuntime: {
      type: Boolean,
      default: false
    },
    showOperation: {
      type: Boolean,
      default: true
    },
    // 因为运行页也用的是同一个组件，但是 getStyleSetting 不需要，所以不设置 required
    getStyleSetting: {
      type: Function,
      default: function (args) {}
    }
  },
  components: {publicCombobox, styleSetting},
  name: 'report',
  mixins: [setStyle],
  data () {
    return {
      //  辅助表列表
      auxiliaryTables: [],
      //  定时更新
      timeList: [
        {name: '5秒', id: '5000'},
        {name: '10秒', id: '10000'},
        {name: '30秒', id: '30000'},
        {name: '1分钟', id: '60000'},
        {name: '10分钟', id: '600000'}
      ],
      report: {
        id: '',
        columns: [],
        tableData: []
      },
      loading: false,
      //  为了主动触发计算属性增加的依赖
      flag: 1
    }
  },
  async mounted () {
    await this.initCreated()
    this.$nextTick(() => {
      if (this.isRuntime && this.data.reportParams.timing) {
        this.timingUpdate(parseFloat(this.data.reportParams.timing))
      }
    })
  },
  beforeDestroy () {
    // 清除定时器
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    initCreated (isRefresh = false) {
      if (isRefresh) {
        this.report.id = this.data.reportParams.auxiliaryTableId
        this.getReport()
      } else {
        this.getDataSourceReports()
        if (this.data.reportParams.auxiliaryTableId) {
          this.report.id = this.data.reportParams.auxiliaryTableId
          this.getDataSourceReports()
          this.getReport()
        }
      }
    },
    getDataSourceReports () {
      this.$axios.get(`/report-api/report/definition/dataSourceReports`)
        .then(res => {
          this.auxiliaryTables = res.data
        })
    },
    getReport () {
      if (this.report.id) {
        this.loading = true
        this.$axios.get(`/report-api/report/definition/${this.report.id}?type=run`)
          .then(res => {
            let report = res.data
            this.report.columns = report.columns.filter(n => !n.hidden)
            let params = {index: 1, size: 1000}
            if (res.data.maxTotal) {
              params.size = Number(res.data.maxTotal)
            }
            this.$axios.get(`/report-api/report/data/${this.report.id}`, {params})
              .then(res => {
                this.loading = false
                this.report.tableData = res.data
                this.$nextTick(() => {
                  this.$refs.table.doLayout()
                })
              }).catch(() => {
                this.loading = false
              })
          }).catch(() => {
            this.loading = false
          })
      }
    },
    formatter (row, column) {
      let col = this.report.columns.find(m => m.id === column.property)
      let displayFormats = []
      let dataFormat = {}
      let data = row[column.property]
      if (!data) return data
      // 处理数据为boolean类型
      if (typeof data === 'boolean') {
        data = data + ''
      }
      if (data || data === 0) {
        // 判断是不是日期 并且日期的值是否存在
        if (col.columnType === 'bit') {
          // 查询的结果为布尔类型的时候, 将值转成 String 类型
          data = data + ''
        } else if (col.columnType === 'html' || col.columnType === 'HTML') {
          // 查询的结果为html的时候, 将值转成 富文本内容查看
          data = '富文本内容查看'
        }
        // 自定义显示的数据处理
        if (col.format && col.format.displayFormats) {
          displayFormats = typeof (col.format.displayFormats) === 'string' ? JSON.parse(col.format.displayFormats) : col.format.displayFormats
          displayFormats.forEach(el => {
            if (el.value && el.condition) {
              let result = this.getDisplayFormatConditionResult(el.type, data, el.condition)
              if (result) {
                data = el.value
              }
            }
          })
        }

        // 基本格式的数据处理
        if (col.format && col.format.dataFormat) {
          dataFormat = typeof (col.format.dataFormat) === 'string' ? JSON.parse(col.format.dataFormat) : col.format.dataFormat
          if (dataFormat.dataType === 'decimal' || dataFormat.dataType === 'int') {
            data = this.handleDecimalDigits(dataFormat.roundWay, data, dataFormat.decimalDigits)
          } else if (dataFormat.dataType === 'percent') {
            data = this.handleDecimalDigits(dataFormat.roundWay, data, dataFormat.decimalDigits) * 100 + '%'
          } else if (dataFormat.dataType === 'date') {
            if (dataFormat.dataformat === 'DA') {
              return moment(data).format('YYYY-MM-DD')
            } else if (dataFormat.dataformat === 'DB') {
              return moment(data).format('YYYY年MM月DD日')
            } else if (dataFormat.dataformat === 'DC') {
              return moment(data).format('YYYY年MM月')
            } else if (dataFormat.dataformat === 'DD') {
              return `${moment(data).year()}年第${moment(data).quarter()}季度`
            } else if (dataFormat.dataformat === 'DE') {
              let halfYear = moment(data).quarter() === 1 || moment(data).quarter() === 2 ? '上半年' : '下半年'
              return `${moment(data).year()}年${halfYear}`
            } else if (dataFormat.dataformat === 'DF') {
              return moment(data).format('MM月DD日')
            } else if (dataFormat.dataformat === 'DG') {
              return moment(data).format('MM月')
            } else if (dataFormat.dataformat === 'DH') {
              let arr = ['日', '一', '二', '三', '四', '五', '六']
              return `周${arr[moment(data).format('d')]}`
            }
          } else {
            if (col.columnType === 'datetime') {
              data = data.includes(',') ? data : moment(data).format('YYYY-MM-DD HH:mm:ss')
            } else if (col.columnType === 'date') {
              data = data.includes(',') ? data : moment(data).format('YYYY-MM-DD')
            }
          }
        }

        return data
      }
    },
    //  保存，渲染辅助表
    async save () {
      if (!this.data.reportParams.auxiliaryTableId) {
        return this.$message.error('请选择辅助表')
      }
      this.report.id = this.data.reportParams.auxiliaryTableId
      await this.getReport()
      this.$nextTick(() => {
        this.$emit('addControls', this.data, false)
      })
    },
    closeDialog () {
      this.$emit('closeDialog')
    },
    resizeChartSize () {
      this.flag++
      this.$nextTick(() => {
        this.$refs.table.doLayout()
      })
    },
    timingUpdate (timer) {
      this.timer = setInterval(() => {
        this.timingRefreshReport()
      }, timer)
    },
    timingRefreshReport () {
      this.loading = true
      let params = {index: 1, size: 1000}
      this.$axios.get(`/report-api/report/data/${this.report.id}`, {params})
        .then(res => {
          this.loading = false
          this.report.tableData = res.data
          this.$nextTick(() => {
            this.$refs.table.doLayout()
          })
        }).catch(() => {
          this.loading = false
        })
    },
    // 恢复默认设置
    recoverSetting () {
      let defaultStyle = this.getStyleSetting(this.data.type)
      defaultStyle && this.$_.assign(this.data, defaultStyle)
    },
    rowStyle () {
      let style = this.getFontStyle(this.data.textStyle)
      // 行内边框线
      if (this.data.LineDivider.width) {
        style['border-bottom-width'] = this.data.LineDivider.width
      }
      if (this.data.LineDivider.color) {
        style['border-bottom-color'] = this.data.LineDivider.color
      }
      if (this.data.LineDivider.style) {
        style['border-bottom-style'] = this.data.LineDivider.style
      }
      return style
    },
    headerRowStyle () {
      let style = this.getFontStyle(this.data.headerFont)
      // 行表头背景色
      if (this.data.headerBackground.backgroundColor || this.data.headerBackground.opacity) {
        style['background-color'] = this.getBgc(this.data.headerBackground)
      }
      // 行内边框线
      if (this.data.LineDivider.width) {
        style['border-bottom-width'] = this.data.LineDivider.width
      }
      if (this.data.LineDivider.color) {
        style['border-bottom-color'] = this.data.LineDivider.color
      }
      if (this.data.LineDivider.style) {
        style['border-bottom-style'] = this.data.LineDivider.style
      }
      return style
    }
  },
  computed: {
    judgeColumn () {
      // 需要过滤含有计算的列
      return column => this.report && this.report.editColumns && !!JSON.parse(this.report.editColumns).find(e => e.id === column.id) && !column.summary
    },
    reportColumns () {
      let data = this.$_.cloneDeep(this.report.columns)
      if (this.flag && this.$refs.customPageReport) {
        let tableWidth = this.$refs.customPageReport.offsetWidth - 20
        if (this.showOperation) {
          tableWidth = tableWidth - 238
        }
        let hasFixedWidth = data.filter(n => {
          if (n.format && n.format.dataFormat && JSON.parse(n.format.dataFormat).width) {
            tableWidth = tableWidth - JSON.parse(n.format.dataFormat).width
            return n
          }
        })
        let length = data.length - hasFixedWidth.length
        let width = tableWidth / length
        data.forEach(n => {
          if (n.format && n.format.dataFormat && JSON.parse(n.format.dataFormat).width) {
            n.runtimeWidth = JSON.parse(n.format.dataFormat).width
          } else {
            n.runtimeWidth = width
          }
        })
        return data
      } else {
        return data
      }
    },
    getClass () {
      return {
        'hasLeft': this.showOperation,
        'update-background': this.data.backgroundAndBorder.backgroundColor || this.data.backgroundAndBorder.opacity,
        'update-font-size': this.data.textStyle.font.size,
        'update-header-size': this.data.headerFont.font.size || this.data.headerBackground.backgroundColor
      }
    }
  }

}
</script>

<style lang="scss">
  .custom-page-report-container {
    width: 100%;
    height: 100%;
    display: flex;
    .left-container {
      width: 230px;
      border-right: 1px solid #DCDCDC;
      height: 100%;
      position: relative;
      .left-content {
        height: calc(100% - 50px);
        padding: 9px 9px 13px 8px;
        overflow: auto;
        .line{
          .title {
            color: #1A1A1A;
            padding: 14px 0 6px;
            font-size: 12px;
          }
          .el-select{
            width: 100%;
          }
        }
        .update-line {
          padding-bottom: 14px;
        }
      }
      .operation {
        text-align: center;
        padding-top: 16px;
        .el-button {
          width: 78px;
          height: 26px;
          border-radius: 3px;
          padding: 0;
        }
        .el-button + .el-button {
          margin-left: 22px;
        }
      }
    }
    .right-container {
      width: 100%;
      height: 100%;
      overflow-x: hidden;
      .table-column-normal{
        .cell.el-tooltip{
          white-space: normal;
        }
      }
      .column-edit {
        padding: 0;
        .cell {
          position: inherit;
          padding: 0 !important;
          overflow: inherit;
        }
      }
      .el-table{
        .el-table__body-wrapper {
          height: calc(100% - 36px);
          tr {
            // 表格边框默认
            border-bottom: 1px solid #EBEEF5;
            td {
              border: inherit;
              color: inherit;
            }
          }
        }
        th.is-leaf{
          background-color: rgb(248, 248, 248);
        }
        .has-gutter {
          tr {
            // 表格边框默认
            border-bottom: 1px solid #EBEEF5;
            th {
              border: inherit;
              text-decoration: inherit;
              div, span {
                text-decoration: inherit;
                color: inherit;
              }
            }
          }
        }
        /* 自定义报表的滚动条触摸展示*/
        ::-webkit-scrollbar-thumb{
          background-color: transparent;
        }
      }
      .el-table::before{
        height: 0;
      }
      .el-table:hover{
        ::-webkit-scrollbar-thumb{
          background-color: #c8c8c8;
          border-radius: 5px;
        }
      }
      .noReport{
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .hasLeft{
      width: calc(100% - 230px);
    }
    .update-background {
      background-color: transparent;
      .el-table {
        background-color: transparent;
        .el-table__body-wrapper {
          background-color: transparent;
          * {
            // 如果设置了背景色，需要把表格原有的颜色变为透明色
            background-color: transparent !important;
          }
        }
        .has-gutter {
          background-color: transparent;
          tr {
            background-color: transparent;
            th {
              background-color: transparent;
              div, span {
                background-color: transparent;
                span {
                  background-color: transparent;
                }
              }
            }
          }
        }
      }
    }
    .update-font-size {
      .el-table {
        .el-table__body-wrapper {
          tr {
            td {
              font-size: inherit;
              div, span {
                font-size: inherit;
              }
            }
          }
        }
      }
    }
    .update-header-size {
      .el-table {
        .has-gutter {
          tr {
            th {
              font-size: inherit;
              background-color: transparent;
              div, span {
                font-size: inherit;
                background-color: transparent;
                span {
                  font-size: inherit;
                  background-color: transparent;
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/design/customPage/report.vue